export const operationCodeToName: Record<string, string> = {
  y0010: "[재관류중재술] 심근경색",
  y0020: "[재관류중재술] 뇌경색",
  y0031: "[뇌출혈수술] 거미막하출혈",
  y0032: "[뇌출혈수술] 거미막하출혈 외",
  y0041: "[대동맥응급] 흉부",
  y0042: "[대동맥응급] 복부",
  y0051: "[담낭담관질환] 담낭질환",
  y0052: "[담낭담관질환] 담도포함질환",
  y0060: "[복부응급수술] 비외상",
  y0070: "[장중첩/폐색] 영유아",
  y0081: "[응급내시경] 성인 위장관",
  y0082: "[응급내시경] 영유아 위장관",
  y0091: "[응급내시경] 성인 기관지",
  y0092: "[응급내시경] 영유아 내시경",
  y0100: "[저체중출생아] 집중치료",
  y0111: "[산부인과응급] 분만",
  y0112: "[산부인과응급] 산과수술",
  y0113: "[산부인과응급] 부인과수술",
  y0120: "[중증화상] 전문치료",
  y0131: "[사지접합] 수족지접합",
  y0132: "[사지접합] 수족지접합 외",
  y0141: "[응급투석] HD",
  y0142: "[응급투석] CRRT",
  y0150: "[정신과적응급] 폐쇄병동입원",
  y0160: "[안과적수술] 응급",
  y0171: "[영상의학혈관중재] 성인",
  y0172: "[영상의학혈관중재] 영유아",
};
